import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface PasswordRecoveryGateProps {
  children: ReactNode;
}

/**
 * Recovery emails currently land on /dashboard with type=recovery.
 * Hold the signed-in app until the user sets a new password.
 */
export function PasswordRecoveryGate({ children }: PasswordRecoveryGateProps) {
  const { passwordRecovery } = useAuth();
  const location = useLocation();

  if (passwordRecovery && location.pathname !== '/reset-password') {
    return <Navigate to="/reset-password" replace />;
  }

  return <>{children}</>;
}
